const Video = ({ aspect, link, title, w, h }) => {
    return (
        <div className={`ratio ratio-${aspect} w-${w}`} style={{ height: h }}>
            <iframe
                src={link}
                title={title}
                allowFullScreen
                style={{ width: '100%', height: '100%' }}
            ></iframe>
        </div>
    )
}

export default Video;
